class ModalContentType {
  None() {
    return 0;
  }
  SendSms() {
    return 1;
  }
  //this has no 2 in implementation
  AuthHistory() {
    return 3;
  }
  ActivateLine() {
    return 4;
  }
  RejectUser() {
    return 5;
  }
  RejectLine() {
    return 6;
  }
  Coupon() {
    return 7;
  }
  EnableCoupon() {
    return 8;
  }
  DisableCoupon() {
    return 9;
  }
  ExtendCoupon() {
    return 10;
  }
}
export default new ModalContentType();
